/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Who_QInputs */

const en_price_page_faq_who_q = /** @type {(inputs: Price_Page_Faq_Who_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who do I pay for a visit?`)
};

const pl_price_page_faq_who_q = /** @type {(inputs: Price_Page_Faq_Who_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komu płacę za wizytę?`)
};

/**
* | output |
* | --- |
* | "Who do I pay for a visit?" |
*
* @param {Price_Page_Faq_Who_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_who_q = /** @type {((inputs?: Price_Page_Faq_Who_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Who_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_who_q(inputs)
	return en_price_page_faq_who_q(inputs)
});